import React, { useState } from "react";
import { IonItem, IonIcon } from "@ionic/react";
import { chevronDown, chevronUp } from "ionicons/icons";
import styled from "styled-components";

const PanelContainer = styled.div`
  border: 1px solid #dbdbdb;
`;
const PanelContent = styled.div`
  padding: 8px 16px 8px 16px;
`;
const PanelTitle = styled(IonItem)`
  font-weight: bold;
  font-size: 1em;
`;

const AccordionPanel = (props) => {
  const [panelContentOpen, setPanelContentOpen] = useState(false);

  const panelContent = panelContentOpen ? (
    <PanelContent>{props.children}</PanelContent>
  ) : null;

  return (
    <PanelContainer>
      <PanelTitle
        lines="full"
        onClick={() => {
          setPanelContentOpen(!panelContentOpen);
        }}
      >
        <div style={props.titleStyle}>{props.title}</div>
        <IonIcon icon={panelContentOpen ? chevronUp : chevronDown} slot="end" />
      </PanelTitle>
      {panelContent}
    </PanelContainer>
  );
};

export default AccordionPanel;
